<ng-template #drawerTpl>
    <ng-content />
</ng-template>
